import ContentSearch from "../../Features/Search/search";

document.addEventListener("DOMContentLoaded", () => {
    const headerSearchButton = document.getElementById("headerSearchButton") as HTMLButtonElement;

    if (headerSearchButton) {
        const searchUrl: string = headerSearchButton.getAttribute('data-searchUrl');

        if (searchUrl) {

            const headerSearch = document.getElementById("headerSearch") as HTMLDivElement;
            if (headerSearch) {
                const headerSearchInput = document.getElementById("headerSearchInput") as HTMLInputElement;

                if (headerSearchInput) {
                    headerSearchButton.addEventListener("click", function () {
                        const q: string = headerSearchInput.value;
                        location.href = `${searchUrl}${q}`;
                    });
                    // Execute a function when the user releases a key on the keyboard
                    headerSearchInput.addEventListener("keyup", function (event) {
                        if (event.key === "Enter" && headerSearchInput.value) {
                            // Cancel the default action, if needed
                            event.preventDefault();
                            // Trigger the button element with a click
                            headerSearchButton.click();
                        }
                    });
                }
            }

            const pageHeaderSearch = document.getElementById("pageHeaderSearch") as HTMLDivElement;
            if (pageHeaderSearch) {
                const pageHeaderSearchButton = document.getElementById("pageHeaderSearchButton") as HTMLButtonElement;
                if (pageHeaderSearchButton) {
                    const pageHeaderSearchInput = document.getElementById("resultSearchInput") as HTMLInputElement;

                    if (pageHeaderSearchInput) {
                        pageHeaderSearchButton.addEventListener("click", function () {
                            const q: string = pageHeaderSearchInput.value;
                            location.href = `${searchUrl}${q}`;
                        });
                        pageHeaderSearchInput.addEventListener("keyup", function (event) {
                            if (event.key === "Enter" && pageHeaderSearchInput.value) {
                                event.preventDefault();
                                pageHeaderSearchButton.click();
                            }
                        });
                    }
                }
            }

        }
    }
});

var contentSearch = new ContentSearch();
contentSearch.init();
